import Vue from 'vue'

import Vant from 'vant';
import 'vant/lib/index.css';
import 'amfe-flexible/index.js'

import router from './router'
import store from './store'

import {
  ImagePreview
} from 'vant';
import App from './App.vue'
Vue.use(ImagePreview);

Vue.use(Vant);
Vue.config.productionTip = false

// // 引入公共样式
// import './assets/css/common.less'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
